import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { userActions } from '../_actions';

function ChangePassword() {
    

	const user = useSelector(state => state.authentication.user);

	const [inputs, setInputs] = useState( () => { 
		return {
			userId: user.shortName,
			password: '',
			newPassword: '',
			repeatPassword: ''
		}
	});

	const [submitted, setSubmitted] = useState(false);
	 const [invalidFormat, setInvalidFormat] = useState(false);
    const { userId, password, newPassword, repeatPassword } = inputs;
	const passwordChanging = useSelector(state => state.user.passwordChanging);
	const status = useSelector(state => state.user.status);

    const alert = useSelector(state => state.alert);
    const dispatch = useDispatch();

    // reset login status
    useEffect(() => { 
		//dispatch(userActions.logout()); 
		// reseting the fields after submit 
		console.log("status: " + status);
		if (status && status.statusCode == 1) {
			setSubmitted(false);
			setInputs( () => {
				return {
					userId: user.shortName,
					password: '',
					repeatPassword: '',
					newPassword: ''
				}
			})
		}
    }, [status]);

    function handleChange(e) {
        const { name, value } = e.target;
		setInputs(inputs => ({ ...inputs, [name]: value }));

		// password limitation will only apply newPassword field 
		if ((name == 'newPassword'))
			setInvalidFormat( value.match("^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[!@#\$%\^&\*]).{8,}$") ? false : true);

    }

    function handleSubmit(e) {
        e.preventDefault();

		setSubmitted(true);
        if ( password && newPassword && repeatPassword ) {	
            dispatch(userActions.changePassword(inputs));
		}
    }

    return (
    		
    		<div >
    			<div className="container-fluid">
		    		<div className="col-md-8" >
		    			<h3>Change Password</h3>
		    		</div>
	    		</div>
	    		
	    		<div className="container-fluid">
	    			<div className="col-md-12 border border-secondary" >
			            <form name="form-inline" onSubmit={handleSubmit} className="col-lg-4 ">
			                <div className="form-group">
			                    <label className="control-label">Current Password</label>
			                    <input type="password" name="password" value={password} onChange={handleChange} className={'form-control' + (submitted && !password ? ' is-invalid' : '')} />
			                    {submitted && !password &&
			                        <div className="invalid-feedback">Current password is required</div>
			                    }
			                </div>
			                <div className="form-group">
			                    <label className="control-label">New Password</label>
			                    <input type="password" name="newPassword" value={newPassword} onChange={handleChange} className={'form-control' + ((submitted && !newPassword) || (!submitted && invalidFormat) ? ' is-invalid' : '')} />
			                    {submitted && !newPassword &&
			                        <div className="invalid-feedback">New password is required</div>
			                    }
								{!submitted && invalidFormat &&
			                        <div className="invalid-feedback">Password should be at least 1 lowercase, 1 uppercase alphabet, 1 numeric and 1 special character with 8 characters long</div>
			                    }
		                    </div>
			                <div className="form-group">
			                    <label className="control-label">Re-enter New Password</label>
			                    <input type="password" name="repeatPassword" value={repeatPassword} onChange={handleChange} className={'form-control' + (submitted && !repeatPassword  ? ' is-invalid' : '')} />
			                    {submitted && !repeatPassword &&
			                        <div className="invalid-feedback">Re-enter New password is required</div>
			                    }
			                </div>
			                <div className="form-group">
				                    <button className="btn btn-primary">
				                        { passwordChanging && <span className="spinner-border spinner-border-sm mr-1"></span> }
				                        Submit
				                    </button>
				            </div>
			                <div className="form-group">
			                {alert.message &&
			                    <div className={`alert ${alert.type}`}>{alert.message}</div>
			                }
			                {/* users.error && <span className="text-danger">ERROR: {users.error}</span> */}
			                </div>
			            </form>
		            </div>
		       </div>
		</div>
	
    );
}

export { ChangePassword };